import { IsBoolean, IsOptional, IsString, IsInt } from 'class-validator';

export class AisRequisitionRequestDto {
  @IsInt()
  businessEntityId: number;

  @IsString()
  @IsOptional()
  providerCode?: string;

  @IsString()
  @IsOptional()
  institutionCode?: string;

  @IsString()
  @IsOptional()
  account?: string;

  @IsString()
  @IsOptional()
  redirect?: string;

  @IsString()
  @IsOptional()
  userLanguage?: string;

  @IsString()
  @IsOptional()
  ssn?: string;

  @IsBoolean()
  @IsOptional()
  accountSelection?: boolean;

  @IsBoolean()
  @IsOptional()
  redirectImmediate?: boolean;

  @IsBoolean()
  @IsOptional()
  useSandboxInstitution?: boolean;

  @IsBoolean()
  @IsOptional()
  isWithdrawalAccount?: boolean;

  @IsInt()
  @IsOptional()
  maxHistoricalDays?: number;

  @IsInt()
  @IsOptional()
  accessValidForDays?: number;

  @IsString()
  @IsOptional()
  ipAddress?: string;

  @IsString()
  @IsOptional()
  userAgent?: string;
}
